import { ContentBlock } from '../../../../lib/types/aemDataModels';
import PureLink, { PureLinkVariant } from '../../../common/Link/PureLink';
import PureAsset from '../../../common/PureAsset/PureAsset';
import PureRichText from '../../../common/PureRichText/PureRichText';
import styles from './Teaser.module.scss';
import { SCALE } from '../../../common/Image/ImageScale';

const Teaser = ({ heading, content, asset, video, link, linkLabel }: ContentBlock): JSX.Element => {
  return (
    <article className={styles.container}>
      <div className={styles.asset}>
        <PureAsset
          asset={asset}
          video={video}
          imageProps={{ imageClassName: styles.image }}
          videoProps={{ containerClass: styles.video }}
          imageScale={SCALE.GRID}
        />
      </div>
      <h3 className={styles.title}>{heading}</h3>
      {!!content && <PureRichText richtext={content} richtextClass={styles.content} />}
      {!!link && (
        <PureLink href={link} className={styles.cta} variant={PureLinkVariant.Link}>
          {linkLabel}
        </PureLink>
      )}
    </article>
  );
};

export default Teaser;
